module.exports = __webpack_public_path__ + "static/media/splash_2.8d98c755.webp";